document.addEventListener('DOMContentLoaded', function() {
    const menuBtn = document.getElementById('menuBtn');
    const menuOverlay = document.getElementById('menuOverlay');
    const dropshadow = document.getElementById('dropshadow');
    const siteHeader = document.querySelector('.site-header');
    const iconElement = menuBtn.querySelector('i');

    menuBtn.addEventListener('click', function() {
        if (menuOverlay.classList.contains('active')) {
            menuOverlay.classList.add('closing');
            dropshadow.style.opacity = '0';
            iconElement.classList.remove('vn-icons-close');
            iconElement.classList.add('vn-icons-menu');
            siteHeader.classList.remove('menu-active');
            setTimeout(() => {
                menuOverlay.classList.remove('entering', 'active', 'full', 'closing');
                menuOverlay.style.visibility = 'hidden';
                dropshadow.style.visibility = 'hidden';
            }, 500);
        } else {
            menuOverlay.classList.remove('closing', 'active', 'full');
            dropshadow.style.visibility = 'visible';
            dropshadow.style.opacity = '0';
            iconElement.classList.remove('vn-icons-menu');
            iconElement.classList.add('vn-icons-close');
            siteHeader.classList.add('menu-active');
            setTimeout(() => {
                dropshadow.style.opacity = '0.2';
            }, 10);
            menuOverlay.style.visibility = 'visible';
            menuOverlay.classList.add('entering');
            setTimeout(() => {
                menuOverlay.classList.add('active');
            }, 400);
            setTimeout(() => {
                menuOverlay.classList.add('full');
            }, 900);
        }
    });
});



document.querySelectorAll('.header-menu > li.menu-item-has-children > a').forEach((menu) => {
    menu.addEventListener('click', (e) => {
        e.preventDefault();
        const parentLi = menu.parentElement;
        document.querySelectorAll('.header-menu li.menu-item-has-children.open').forEach((openMenu) => {
            if (openMenu !== parentLi) {
                openMenu.classList.remove('open');
            }
        });
        parentLi.classList.toggle('open');
    });
});


